import { Theme, css } from '@emotion/react'

export const container = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 461px;
  max-width: calc(100% - 10px);
  gap: 15px;
  padding: 22px;
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.medium};
  border-radius: 24px;
  box-sizing: border-box;
`

export const title = (theme: Theme) => css`
  font-weight: 700;
  color: ${theme.typographyColors.typographyTwo};
  margin-bottom: 7px;
`

export const hint = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyThree};
  margin-top: 7px;
`
